import app from "firebase/app";
import FirebaseContext from "./firebaseContext";
import React, { useState, useEffect } from "react";
import "firebase/auth";
import "firebase/firebase-firestore";

var config = {
  apiKey: "AIzaSyC8e9mHJgpM-BauxFu8SXgzfTjqHAHG784",
  authDomain: "anglescina-bic.firebaseapp.com",
  databaseURL: "https://anglescina-bic.firebaseio.com",
  projectId: "anglescina-bic",
  storageBucket: "anglescina-bic.appspot.com",
  messagingSenderId: "1047353314099",
  appId: "1:1047353314099:web:82645e67037fb8ee528c46",
  measurementId: "G-D7YM7GRPEQ"
};
const FirebaseState = props => {
  if (!app.apps.length) {
    try {
      app.initializeApp(config);
    } catch (err) {
      console.error("Errorrrr", err.stack);
    }
  }

  const auth = app.auth();
  const db = app.firestore();

  const [authenticated, setAuthenticated] = useState(false);

  const login = async (email, password) => {
    const res = await auth.signInWithEmailAndPassword(email, password);
  };

  return (
    <div>
      <FirebaseContext.Provider value={{ auth, db, login }}>
        {props.children}
      </FirebaseContext.Provider>
    </div>
  );
};

export default FirebaseState;
